import { render, staticRenderFns } from "./ProgramPageInfo.vue?vue&type=template&id=263a2bfa"
import script from "./ProgramPageInfo.vue?vue&type=script&lang=js"
export * from "./ProgramPageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports